import { HttpHeaders } from '@angular/common/http';

export enum AuditActionType {
  CREATE = 'POST',
  UPDATE = 'PUT',
  DELETE = 'DELETE',
  READ = 'GET',
}

/**
 * Parameters for creating an audit header.
 */
export interface IAuditHeaderOptions {
  entityId: string | number;
  section: string;
  subsection?: string;
  action?: string;
}

/**
 * Helper for creating audit headers.
 */
export class AuditHelper {
  /**
   * Creates a single JSON header for auditing.
   */
  public static createAuditHeader(options: IAuditHeaderOptions): HttpHeaders {
    const { entityId, ...rest } = options;
    const auditContext = { ...rest, entityId: entityId?.toString() ?? 'Unknown' };

    return new HttpHeaders({
      'X-Audit-Context': JSON.stringify(auditContext),
    });
  }
}
